import { CALL_API } from "redux-api-middleware"
import { get, post, put, destroy } from "utils/network"

export const fetchAdvising = () => (dispatch, getState) => {
  if (getState().enrolment.get("advisingHasFetched")) {
    return Promise.resolve()
  }
  const request = get("/enrolment/advising")
  request.types = ["ENROL_REQ", "ENROL_ADV_SUCC", "NOTIF_FAIL"]
  return dispatch({ [CALL_API]: request })
}

export const fetchOfferings = () => (dispatch, getState) => {
  if (getState().enrolment.get("offeringsHasFetched")) {
    return Promise.resolve()
  }
  const request = get("/offerings")
  request.types = ["ENROL_REQ", "ENROL_OFF_SUCC", "NOTIF_FAIL"]
  return dispatch({ [CALL_API]: request })
}

export const fetchSubjects = () => (dispatch, getState) => {
  if (getState().enrolment.get("subjectsHasFetched")) {
    return Promise.resolve()
  }
  const request = get("/enrolment/subjects")
  request.types = ["ENROL_REQ", "ENROL_SUB_SUCC", "NOTIF_FAIL"]
  return dispatch({ [CALL_API]: request })
}

export const apply = (payload, semcampID) => {
  const request = post("/enrolment/apply", payload)
  request.types = [
    "ENROL_REQ",
    {
      type: "ENROL_APP_SUCC",
      meta: {
        msg:
          "Application successful. While your application is still pending, you may modify your subjects.",
        semcampID,
      },
    },
    "NOTIF_FAIL",
  ]
  return { [CALL_API]: request }
}

// returns updated list of enrolled subjects
export const removeSubject = (scSubjectID, semcampID) => {
  const request = destroy(`/enrolment/subjects/${scSubjectID}`)
  request.types = [
    "ENROL_REQ",
    {
      type: "ENROL_DELSUB_SUCC",
      meta: { semcampID },
    },
    "NOTIF_FAIL",
  ]
  return { [CALL_API]: request }
}

export const addSubjects = (payload, semcampID) => {
  const request = post("/enrolment/subjects/add", payload)
  request.types = [
    "ENROL_REQ",
    {
      type: "ENROL_ADDSUB_SUCC",
      meta: { semcampID },
    },
    "NOTIF_FAIL",
  ]
  return { [CALL_API]: request }
}

// cancel enrolment and remove all subjects
export const cancelEnrolment = semcampID => {
  const request = post("/enrolment/cancel")
  request.types = [
    "ENROL_REQ",
    {
      type: "ENROL_CANCEL_SUCC",
      meta: {
        msg: "Application for enrolment successfully canceled.",
        semcampID,
      },
    },
    "NOTIF_FAIL",
  ]
  return { [CALL_API]: request }
}

// mark subject as withdraw
export const requestWithdraw = (enrolledID, undo) => {
  const request = put(`/enrolment/subjects/withdraw/${enrolledID}`, { undo })
  request.types = ["ENROL_REQ", "ENROL_WITH_SUCC", "NOTIF_FAIL"]
  return { [CALL_API]: request }
}

// mark subject as add
export const requestAddSubjects = payload => {
  const request = post("/enrolment/subjects/add-request", payload)
  request.types = [
    "ENROL_REQ",
    {
      type: "NOTIF_SUCC",
      meta: { msg: "Add request successful." },
    },
    "NOTIF_FAIL",
  ]
  return { [CALL_API]: request }
}

export const getSimilarSubjects = offeringID => {
  const request = get(`/offerings/${offeringID}/similar`)
  request.types = ["NOOP", "NOOP", "NOTIF_FAIL"]
  return { [CALL_API]: request }
}

export const changeSection = (fr, to) => {
  const request = put("/offerings/change-section", {
    offering_subject_id: fr,
    to: to,
  })
  request.types = ["CHANGE_SEC_REQ", "CHANGE_SEC_SUCC", "CHANGE_SEC_FAIL"]
  return { [CALL_API]: request }
}



// WEBPACK FOOTER //
// ./src/containers/Enrolment/actions.js